// Money is integer VND (vin) everywhere: BigInt in the API, string on the wire.
export function bpsOf(amount, bps) {
    if (!Number.isInteger(bps) || bps < 0)
        throw new RangeError('bps must be a non-negative integer');
    return (amount * BigInt(bps)) / 10000n;
}
export function parseMoney(value) {
    if (typeof value === 'bigint')
        return value;
    if (typeof value === 'number') {
        if (!Number.isSafeInteger(value))
            throw new RangeError('money must be a safe integer');
        return BigInt(value);
    }
    if (typeof value === 'string' && /^-?\d{1,19}$/.test(value.trim()))
        return BigInt(value.trim());
    throw new RangeError('invalid money value');
}
export function moneyToString(value) {
    return typeof value === 'bigint' ? value.toString() : String(Math.trunc(value));
}
const fmt = new Intl.NumberFormat('vi-VN');
export function formatVnd(value) {
    const v = typeof value === 'string' ? BigInt(value) : value;
    return fmt.format(v);
}
//# sourceMappingURL=money.js.map